export default {
  "layout": "EVFA8",
  "cell": "_4YBTa"
};